
























import { Component, Prop, Vue } from 'vue-property-decorator';
import { StudentDraggableExtraArea } from '@/models/student/student-draggable-extra-area';
import { schoolClassChangeModule } from '@/store/modules/frames/school-class-change.module';
import GSchoolClassChangeWorkSpaceDraggable from '@/views/GSchoolClassChange/GSchoolClassChangeWorkSpaceDraggable.vue';
import GSchoolClassChangeToolBar from '@/views/GSchoolClassChange/GSchoolClassChangeToolBar.vue';
import { GEnum } from '@/constants/enum.defination';

@Component({
  name: 'GSchoolClassChangeWorkSpace',
  components: { GSchoolClassChangeToolBar, GSchoolClassChangeWorkSpaceDraggable },
  computed: {},
  methods: {},
})
export default class GSchoolClassChangeWorkSpace extends Vue {
  @Prop({ default: () => {} }) options: any;

  mounted() {}

  get studentDraggableExtraArea(): StudentDraggableExtraArea {
    return schoolClassChangeModule.studentDraggableExtraArea;
  }

  get dragAreaTypeWorkSpace(): GEnum.DragAreaType {
    return GEnum.DragAreaType.TypeWorkSpace;
  }
}
